const DEFAULT_API_ORIGIN = "https://pharmacy-api-wm8b.onrender.com";

export const apiOrigin = (process.env.NEXT_PUBLIC_API_URL ?? DEFAULT_API_ORIGIN).replace(/\/$/, "");
export const apiBaseUrl = `${apiOrigin}/api`;
